import { Model, modelRegistry } from './Model';
import { Table } from '.';
export class Sector extends Model {
    static entity = 'sectors';
    id = null;
    name = null;
    image = null;
    image_url = null;
    type = 'default';
    created_at = null;
    updated_at = null;
    tables = [];
    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            image: this.attr(null),
            image_url: this.attr(null),
            type: this.attr('default'),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            tables: this.attr([], (value) => (value || []).map(item => new Table(item))),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
}
export default Sector;
modelRegistry.register('Sector', Sector);
//# sourceMappingURL=Sector.js.map